import { BaseMutationTypes } from '../BaseMutationTypes';

export class WorkflowKanbanJobMutationTypes extends BaseMutationTypes {
  public static readonly SetPopupFieldsSchema = 'SET_POPUP_FIELDS_SCHEMA';
  public static readonly SetCardMoveContext = 'SET_CARD_MOVE_CONTEXT';
  public static readonly SetPopupFieldStatus = 'SET_POPUP_FIELD_STATUS';
  public static readonly SetLastCardMove = 'SET_LAST_CARD_MOVE';
  public static readonly ReleaseLock = 'RELEASE_LOCK';
}
